export const standardFilterFields = [
	'state',
	'sourceOrganizationId',
	'targetOrganizationId',
] as const;
export const dateFilterFields = ['createdAt', 'updatedAt'] as const;

export const filterFields = [...standardFilterFields, ...dateFilterFields] as const;
